import {
  CREATE_GROUP,
  CREATE_GROUP_FAILED,
  CREATE_GROUP_RESET_STATE,
  CREATE_GROUP_SUCCESS,
} from "../actions/action_createGroup";

const initialState = {
  error: null,
  data: null,
  loading: null,
  initial: true,
};

const createGroupReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_GROUP:
      return {
        ...state,
        data: null,
        error: null,
        loading: true,
        initial: false,
      };
    case CREATE_GROUP_FAILED:
      return {
        ...state,
        data: null,
        error: action.payload,
        loading: false,
        initial: false,
      };
    case CREATE_GROUP_SUCCESS:
      return {
        ...state,
        data: action.payload,
        error: null,
        loading: false,
        initial: false,
      };
    case CREATE_GROUP_RESET_STATE:
      return initialState;
    default:
      return state;
  }
};

export default createGroupReducer;
